export const AVATAR_API_BASE_URL = "https://app.easy.tools/api/pages/generated/avatar";
const IMAGE_API_BASE_URL = "https://app.easy.tools/api/pages/generated/img";

export const getPaceholderImageUrl = (size: string, color?: string) => {
    return `${IMAGE_API_BASE_URL}/${size}${color ? `/${color.replace("#", "")}` : ""}`;
};

export const PAGE_SECTION_KINDS = {
    BLOCK: "block",
    TOOL: "tool",
};

export const PAGE_SECTION_TYPES = {
    BLOCK: "block",
    COFFEE: "coffee",
    COOKIE: "cookie",
    FAQ: "faq",
    LEGAL: "legal",
    LOVE: "love",
    PRICING: "pricing",
    TICKER: "ticker",
};
